import { fmtTL, fmtNum } from "../../lib/format";

const th = (a) => `px-3 py-1.5 text-[10px] uppercase tracking-wider text-slate-500 font-semibold ${a === "r" ? "text-right" : "text-left"}`;
const num = "numeric-cell px-3 py-1.5 text-xs";
const HEAD = [["Kalem", "l"], ["Üst Hizmet", "l"], ["Esas", "l"], ["Kişi / Gün", "r"], ["Birim Tutar", "r"], ["Tutar", "r"]];

// Kalem satırları: Kişi Bazlı → kişi sayısı × fiyat (gün 0 olsa da); Aylık → puantaj günü × fiyat ÷ 30
const kalemRows = (kalems, people, workDays) => kalems.map((k) => {
  const person = k.basis === "gunluk";
  const qty = person ? people : workDays;
  const unitPrice = k.price == null ? null : person ? k.price : k.price / 30;
  return { ...k, person, qty, unitPrice, amount: unitPrice == null ? 0 : qty * unitPrice };
});

function KalemRow({ r, testid }) {
  return (
    <tr className="border-t border-slate-100" data-testid={testid}>
      <td className="px-3 py-1.5 text-xs font-medium">{r.name}</td>
      <td className="px-3 py-1.5 text-xs text-slate-500">{r.parent_name}</td>
      <td className="px-3 py-1.5 text-xs"><span className={`px-1.5 py-0.5 rounded text-[9px] font-bold uppercase ${r.person ? "bg-sky-100 text-sky-700" : "bg-violet-100 text-violet-700"}`}>{r.person ? "Kişi Bazlı" : "Aylık"}</span></td>
      <td className={num}>{fmtNum(r.qty)} {r.person ? "kişi" : "gün"}</td>
      <td className={num}>{r.unitPrice == null ? <span className="px-1.5 py-0.5 rounded bg-amber-100 text-amber-800 text-[9px] font-bold uppercase" title="Proje kartında bu kalemin fiyatı girilmemiş">Fiyat yok</span> : <>{fmtTL(r.unitPrice)}{!r.person && <div className="text-[9px] text-slate-400">{fmtTL(r.price)} ÷ 30</div>}</>}</td>
      <td className={`${num} font-semibold`} data-testid={`${testid}-amount`}>{fmtTL(r.amount)}</td>
    </tr>
  );
}

// Firma gider payı kalem dökümü — bölge bölge: her bölgenin kendi kişi ve puantaj gün sayısıyla kalemler + bölge ara toplamı; en altta genel toplam
export default function ClaimOverheadTable({ inv, testid }) {
  const kalems = inv.overhead_kalems || [];
  if (!kalems.length) return null;
  const regions = (inv.overhead_regions || []).length ? inv.overhead_regions : [{ region_name: "", people: inv.people, work_days: inv.work_days, amount: inv.overhead_amount }];
  const byRegion = regions.length > 1 || !!regions[0].region_name;
  return (
    <div className="border-t-2 border-violet-200" data-testid={testid}>
      <div className="px-3 py-1.5 bg-violet-50 flex flex-wrap items-center justify-between gap-2">
        <span className="text-[10px] uppercase tracking-wider font-bold text-violet-900">Firma Gider Payı Kalem Dökümü{byRegion ? " — Bölge Bazında" : ""} <span className="ml-1 font-normal normal-case text-violet-700">(Kişi Bazlı: bölgedeki personel sayısı × fiyat — puantaj günü 0 olsa da · Aylık: bölgedeki puantaj günü × fiyat ÷ 30)</span></span>
        <span className="text-[10px] text-violet-800" data-testid={`${testid}-summary`}>{byRegion ? `${regions.length} bölge · ` : ""}{inv.people} personel · {fmtNum(inv.work_days)} puantaj günü · {kalems.length} kalem</span>
      </div>
      <div className="overflow-x-auto">
      <table className="w-full tbl">
        <thead><tr>{HEAD.map(([h, a]) => <th key={h} className={th(a)}>{h}</th>)}</tr></thead>
        <tbody>
          {regions.map((rg) => {
            const rows = kalemRows(kalems, rg.people, rg.work_days);
            const key = rg.region_name || "none";
            return [
              byRegion && (
                <tr key={`${key}-h`} className="border-t border-slate-200 bg-slate-100/80" data-testid={`${testid}-region-${key}`}>
                  <td colSpan={3} className="px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider text-slate-700">{rg.region_name || "Bölge Yok"}</td>
                  <td colSpan={3} className="px-3 py-1.5 text-[10px] text-right text-slate-600" data-testid={`${testid}-region-${key}-stats`}><b>{rg.people}</b> kişi · <b>{fmtNum(rg.work_days)}</b> puantaj günü</td>
                </tr>
              ),
              ...rows.map((r) => <KalemRow key={`${key}-${r.id}`} r={r} testid={`${testid}-row-${key}-${r.id}`} />),
              byRegion && (
                <tr key={`${key}-t`} className="border-t border-slate-200 bg-slate-50" data-testid={`${testid}-region-total-${key}`}>
                  <td colSpan={5} className="px-3 py-1.5 text-[10px] font-semibold uppercase tracking-wider text-slate-500 text-right">{rg.region_name || "Bölge Yok"} Firma Gider Payı</td>
                  <td className={`${num} font-bold text-slate-900`}>{fmtTL(rg.amount)}</td>
                </tr>
              ),
            ];
          })}
        </tbody>
        <tfoot>
          <tr className="border-t-2 border-violet-200 bg-violet-50/60">
            <td colSpan={5} className="px-3 py-1.5 text-[10px] font-bold uppercase tracking-wider text-violet-900 text-right">Firma Gider Payı Toplamı</td>
            <td className={`${num} font-bold text-violet-900`} data-testid={`${testid}-total`}>{fmtTL(inv.overhead_amount)}</td>
          </tr>
        </tfoot>
      </table>
      </div>
    </div>
  );
}
